import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  width: 100%;

  .delivery_destination, .easy_news {
    margin-bottom: 1.25rem;
    align-items: center;
    &.blank {
      margin: 0;
    }
  }

  a.add_destination {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    vertical-align: middle;
    &:focus {
      outline: none;
    }
    .icon {
      margin-right: 4px;
    }
  }
  .add_destination-notification {
    display: flex;
    align-items: center;
    padding: 8px;
    margin-top: 0.5rem;
    color: #4C8FC3;
    background-color: #e5edf8;
    border-radius: 4px;
    .icon {
      color: #1976d2;
      margin-right: 4px;
    }
    p {
      font-size: 14px;
      margin: 0;
    }
  }
  a.display-selection {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    vertical-align: middle;
    &:focus {
      outline: none;
    }
    .icon {
      margin-right: 4px;
    }
  }
`

export const Separator = styled.div`
  margin: 1.5rem 0 0.25rem;
  border-bottom: 1px dashed #ccc;
  &.display-selection-separator {
    margin: 0 0 1.25rem;
  }
`

export const FieldUnit = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  margin-bottom: 1.5rem;

  &.newsSegment {
    margin-bottom: 0;
  }

  a.newsSegmentLink {
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-top: 1.5rem;

    color: #1976d2;
    line-height: 1.5rem;
    .icon {
      margin-right: 0.25rem;
    }
    &:hover {
      color: #13599e;
    }
  }
`

export const LabelBox = styled.div`
  flex-grow: 1;
  width: calc(15% - 1rem);
  margin-left: 1rem;
  text-align: right;
  font-weight: bold;
`

export const FieldBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 50rem;

  label {
    display: block;
    margin-right: 1.5rem;
    font-weight: 400;
    cursor: pointer;
    transition: opacity .2s;
    &:hover {
      opacity: .75;
    }
  }
  input[type="radio"] {
    cursor: pointer;
    &:focus {
      outline: 0;
    }
    &:hover + label {
      opacity: .75;
    }
  }

  a.addDestination {
    margin-left: 2rem;
    display: inline-flex;
    align-items: center;
    gap: 0.3125rem;
  }

  a.deteteDestination {
    display: flex;
    align-items: center;
    color: #757575;
    margin-left: auto;
    text-decoration: none;
    transition: color .2s;
    .icon {
      margin-right: 0.25rem;
    }
    &:hover {
      color: #000;
    }
  }
`

export const SelectorTitle = styled.p`
  margin: 1.2rem 0 0.25rem;
  font-size: 0.875rem;
  line-height: 24px;
`

export const DestinationSelector = styled.div`
.warningMessage {
  color: red;
  margin-top: 0.25rem;
}
.selectDestination {
  max-width: 22rem;
  z-index: 1000;
}
`

export const MemberTabs = styled.div`
  display: flex;
  flex-flow: column wrap;
  margin-top: 1rem;
`

export const TabHeads = styled.div`
  display: flex;
  gap: 1rem;
  color: #757575;
  font-size: 0.875rem;

  a,
  span {
    display: flex;
    align-items: center;
    line-height: 1.5rem;
    padding: 0.625rem 1rem;
    color: #333;
    text-decoration: none;
    background: #F5F5F5;
    border: 1px solid #CCC;
    border-radius: 0.25rem 0.25rem 0 0;
  }
  a {
    &:hover {
      transition: background-color .2s;
      background: #FFF;
    }
  }
  span {
    background: #FFF;
    border-bottom-color: #FFF;
  }
  .count {
    min-width: 1.5rem;
    padding: 0 0.5rem;
    margin-left: 0.5rem;
    line-height: 1.5rem;
    color: #757575;
    font-weight: bold;
    background-color: #ccc;
    border-radius: 0.75rem;
    &.active {
      color: #FFF;
      background-color: #2ECC71;
    }
    &.pulse {
      animation: addCount 0.25s ease-in-out;
    }
  }
  @keyframes addCount {
    0% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(1.15);
    }
    100% {
      transform: scale(1);
    }
  }
`

export const CheckBoxesTabHeadActive  = styled.div`
  z-index: 1;
`

export const CheckBoxesTabHead = styled.div`
`

export const SelectedMembersTabHeadActive = styled.div`
  z-index: 1;
`
export const SelectedMembersTabHead = styled.div`
`


export const CheckBoxesTab = styled.div`
  width: 100%;
  margin-top: -1px;
  border: 1px solid #CCC;
  border-radius: 0 0.25rem 0.25rem 0.25rem;

  ul {
    max-height: calc(75vh - 16rem);
    overflow-y: auto;
  }

  .searchMembers {
    display: flex;
    align-items: center;
    padding: 0.625rem;
    .icon {
      color: #757575;
      margin-right: 0.5rem;
    }
    input {
      padding: 0;
      line-height: 1.5rem;
      border: 0;
      &::placeholder {
        font-style: normal;
      }
    }
  }
`

export const SelectAll = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  line-height: 1.5rem;
  padding: 0.5rem 0.625rem;

  background: #F5F5F5;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  > div {
    flex: 0 0 auto;
    &:first-child {
      width: 100px;
    }
    &:nth-child(2) {
      width: calc(70% - 50px);
    }
    &:nth-child(3) {
      width: calc(30% - 50px);
    }
  }

  .SelectAllCheckbox {
    display: inline-flex;
    color: #757575;
    font-size: 0.75rem;
    line-height: 1.5rem;
    padding: 1px 0.5rem;

    border-radius: 0.25rem;
    border: 1px solid #CCC;
    background: #FFF;
    transition: border-color .2s;
    cursor: pointer;
    vertical-align: middle;

    input,
    label {
      cursor: pointer;
      &:focus {
        outline: 0;
      }
    }
    &:hover {
      border-color: #757575;
    }
  }

  .membersNameAndNumber {
    color: #757575;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
  }
`;

export const UlUser = styled.ul`
  max-height: calc(75vh - 16rem);
  overflow-y: auto;
`;

export const LiUser = styled.li`
  &:last-child {
    &.selectedUsers,
    > label {
      border-bottom: 0;
    }
  }
  &.selectedUsers,
  > label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5rem;
    padding: 0.625rem;
    font-size: 0.875rem;
    font-weight: 400;
    border-bottom: 1px solid #CCC;
    transition: background-color .2s;
    cursor: pointer;
    &:hover {
      background-color: #EBF5FB;
    }
    > div {
      flex: 0 0 auto;
      padding-right: 1rem;
      word-break: break-all;
      &:first-child {
        display: flex;
        align-items: center;
        width: 100px;
        padding-left: 0.563rem;
        input:focus {
          outline: 0;
        }
      }
      &:nth-child(2) {
        width: calc(70% - 50px);
      }
      &:nth-child(3) {
        width: calc(30% - 50px);
      }
    }
  }

  &.isActive {
    > label {
      background-color: #EAFAF1;
    }
  }

  &.selectedUsers {
    &:hover {
      background-color: #F5F5F5;
    }
    > div {
      flex: 0 0 auto;
      word-break: break-all;
      &:first-child {
        width: calc(70% - 30px);
        padding-left: 0.563rem;
      }
      &:nth-child(2) {
        width: calc(30% - 30px);
      }
      &:nth-child(3) {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        padding: 0;
        a {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #757575;
          width: 1.5rem;
          height: 1.5rem;
          transition: color .2s;
          &:hover {
            color: #000;
            &:before {
              content: '';
              position: absolute;
              top: -0.25rem;
              left: -0.25rem;
              width: 2rem;
              height: 2rem;
              background-color: rgba(0, 0, 0, .1);
              border-radius: 50%;
              animation: Balloon .1s ease-in-out;
            }
          }
        }
      }
    }
  }
  @keyframes Balloon {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const SelectedMembersTab = styled.div`
  border: 1px solid #CCC;
  width: 100%;
  margin-top: -1px;
  border-radius: 0 0.25rem 0.25rem 0.25rem;

  ul {
    max-height: calc(75vh - 16rem);
    overflow-y: auto;
  }

  .nameAndRoomNumber {
    display: flex;
    align-items: center;
    line-height: 1.5rem;
    padding: 0.625rem 1.188rem;
    color: #757575;
    font-size: 0.875rem;
    border-bottom: 1px solid #CCC;
    .name {
      width: calc(70% - 50px);
    }
    .roomNumber {
      width: calc(30% - 50px);
    }
  }

  .emptyMessage {
    font-size: 1rem;
    padding: 3rem 1.188rem;
    text-align: center;
  }
`
// これかららくらくお知らせのフォームに使ってるパーツです

export const ScheduleBox = styled.div`
  margin-top: 1rem;
  div {
    &.useTime {
      input[type="checkbox"] {
        margin: 0 0.5rem 0 1rem;
        &.no-margin-left {
          margin-left: 0;
        }
      }
      .selectTimeRadio {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        .radioOption {
          display: flex;
          align-items: center;
          &:nth-child(5) {
            width: 50%;
          }
          &.customRadio {
            height: 38px;
            margin-top: 0.5rem;
          }
        }
        .customTimeSelect {
          display: flex;
          align-items: center;
          margin-top: 0.5rem;
          label {
            margin-left: 16px;
          }
          .colon {
            margin: 0 0.25rem;
          }
        }
      }
      .selectTimeForDayTime {
        width: 80px;
      }
    }
  }
  .selectField {
    margin-bottom: 1rem;
  }
  .datePickerRange {
    max-width: 140px;
    margin-right: 0.5rem;
  }
  .datetimeLabel {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 0.75rem;
    &.mt {
      margin-top: 1rem;
    }
  }
  .range-sign {
    margin: 0 0.25rem;
  }
  .spacer {
    display: block;
    margin-bottom: 1.5rem;
  }
`
